import { Component, OnInit } from '@angular/core';
import {NavigationEnd, NavigationStart, Router, RouterOutlet} from "@angular/router";
import {animate, query, style, transition, trigger} from "@angular/animations";
import {WebSocketService} from "../services/web-socket.service";
import { SiteChromeService } from '../services/site-chrome.service';


export const routeAnim = trigger('routeAnim', [
  transition('* <=> search', [
    query(':enter', [
      style({ opacity: 0, transform: 'scale(0.97)' })
    ], { optional: true }),
    query(':leave', [
      animate('150ms ease', style({ opacity: 0, transform: 'scale(0.97)' }))
    ], { optional: true }),
    query(':enter', [
      animate('250ms 100ms ease', style({ opacity: 1, transform: 'scale(1)' }))
    ], { optional: true }),
  ])
]);

@Component({
    selector: 'app-pages-component',
    templateUrl: './pages-component.component.html',
    styleUrls: ['./pages-component.component.scss'],
    animations: [routeAnim],
    standalone: false
})
export class PagesComponentComponent implements OnInit {
  isLoading = false;
  isSearchPage = false;

  getRoute(outlet: RouterOutlet) {
    return outlet.activatedRouteData['anim'] ?? 'default';
  }

  /** Set by the VIP personal shell, which has its own top bar. */
  chromeHidden = false;

  /** Site header / footer hidden: search page, VIP dashboard, or the VIP personal area. */
  get hideSiteChrome(): boolean {
    return this.isSearchPage || this.chromeHidden;
  }

  constructor(private router: Router, _ws: WebSocketService, siteChrome: SiteChromeService) {
    siteChrome.hidden$.subscribe(hidden => this.chromeHidden = hidden);
    // Inject WebSocketService eagerly so its loggedIn$ subscription
    // is always active, even when <app-chat-room> is hidden by *ngIf
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) this.isLoading = true;
      if (event instanceof NavigationEnd)   this.isLoading = false;
      if (event instanceof NavigationEnd) {
        this.isSearchPage = event.urlAfterRedirects.startsWith('/search') ||
                            event.urlAfterRedirects.startsWith('/personal/vip-dashboard');
      }
    });
  }

  ngOnInit(): void {}
}
